// extracted by mini-css-extract-plugin
export default {"name_wrap":"Title_name_wrap__1vp8x","name":"Title_name__eJP4E"};